<template>
    <div class="text-center w-full pb-10 -mb-16">
        <div>
            <img class="inline-block" src="../../assets/images/tick-white.svg" alt="" />
        </div>

        <div class="page-title">Your appointment is booked!</div>

        <p>We've sent confirmation to your email address</p>

        <div class="overlay">
            <div class="container mx-auto">
                <div class="item-1 md:w-1/3">
                    <div><img class="inline" src="../../assets/images/calendar-white.svg" alt="" /></div>
                    <div class="text-lead">{{ appointmentDate.format('dddd Do MMMM') }}</div>
                    <div>{{ appointmentDate.format('HH:mm') }}</div>
                </div>

                <div v-if="appointmentData.clinic.ClinicID == videoClinicID" class="item-2 md:w-1/4">
                    Online video appointment
                </div>

                <div v-else class="item-2 md:w-1/4">
                    <div><img class="inline" src="../../assets/images/map-marker-white.svg" alt="" /></div>
                    <div class="text-lead">{{ appointmentData.clinic.ClinicName }}</div>
                    <div class="text-sm">
                        <a :href="viewOnMapUrl" rel="noopener noreferrer nofollow" target="_blank">
                            View on map
                        </a>
                    </div>
                </div>

                <div class="item-3 md:w-1/4">
                    <div class="text-lead">{{ appointmentData.therapist.Name }}</div>
                    <div>Clinician</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateTime from "../../lib/DateTime";

    export default {
        name: 'appointment-overview',

        data() {
            let appointmentData;

            try {
                appointmentData = JSON.parse(window.localStorage.getItem('appointment'));
            } catch (error) {
                appointmentData = null;
            }

            return {
                appointmentData,
            };
        },

        computed: {
            appointmentDate() {
                return DateTime.merge(
                    this.appointmentData.appointment.Date, this.appointmentData.appointment.Time
                );
            },

            viewOnMapUrl() {
                return 'https://maps.google.com/?q='
                    + encodeURIComponent(this.appointmentData.clinic.ClinicName) + ','
                    + encodeURIComponent(this.appointmentData.clinic.Address1) + ','
                    + encodeURIComponent(this.appointmentData.clinic.Postcode);
            },

            videoClinicID() {
                return process.env.VUE_APP_VIDEO_CLINIC_ID;
            },
        },

        mounted() {
            if (this.appointmentData) {
                this.$gtm.trackView('Complete', '/complete');
            } else {
                this.$router.push({ name: 'home' });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .page-title {
        @apply text-white mb-0;

        background: none;
        -webkit-background-clip: unset;
        -webkit-text-fill-color: unset;
    }

    .overlay {
        @apply mt-8 py-8;

        @screen md {
            .container {
                @apply flex flex-row items-center justify-center;
            }

            .item-1 {
                order: 2;
                @apply mx-8 px-8;
                border: 1px solid rgba(255, 255, 255, .5);
                border-top: 0;
                border-bottom: 0;
            }

            .item-2 {
                order: 3;
            }

            .item-3 {
                order: 1;
            }
        }

        @screen lg {
            .item-1 {
                .text-lead {
                    @apply text-3xl;
                }
            }
        }
    }
</style>
